export const startTimer = (time: number) => {
  const min = Math.floor(time / 60);
  const seconds = time % 60;

  let result = `${min < 10 ? "0" + min : min} мин : ${
    seconds < 10 ? "0" + seconds : seconds
  } сек`;
  if (time === 0) {
    result = "Время истекло!";
  }

  return result;
};
